import { useEffect, useRef, useState } from 'react';
import RevertChange from './TimelinePlayerActionBar/RevertChanges';
import AddChapter from './TimelinePlayerActionBar/AddChapter';
import AddScene from './TimelinePlayerActionBar/AddScene';
import PlaybackSpeed from './TimelinePlayerActionBar/PlaybackSpeed';
import PreviousChapter from './TimelinePlayerActionBar/PreviousChapter';
import NextChapter from './TimelinePlayerActionBar/NextChapter';
import PlayPause from './TimelinePlayerActionBar/PlayPause';
import PlayerTime from './TimelinePlayerActionBar/PlayerTime';
import ZoomRange from './TimelinePlayerActionBar/ZoomRange';
import PlayerTimelineButton from './TimelinePlayerActionBar/PlayerTimelineButton';
import { zoomLevelStore } from './store/zoomLevel';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { FPS_24 } from '@/App/remotion/constants';
import useRemotionPlayerDuration from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerDuration';

export const ClipNewTimeline = () => {
  const timelineContainerRef = useRef<HTMLDivElement>(null);
  const [isExpanded, setIsExpanded] = useState(true);
  const fullRecordingDuration = useRemotionPlayerDuration();

  const { clipId } = useClipsContext();

  useEffect(() => {
    if (clipId && fullRecordingDuration !== Infinity) {
      // !! Hitesh this calculation should include the intro outro button in cause intro and outro not added.
      const timelineContainerWidth = timelineContainerRef.current?.clientWidth || 0;
      if (!timelineContainerWidth) return;
      const calculatedZoomValue = timelineContainerWidth / (fullRecordingDuration * FPS_24);
      zoomLevelStore.set(() => calculatedZoomValue);
    }
  }, [clipId, fullRecordingDuration]);

  return (
    <>
      <div
        ref={timelineContainerRef}
        className="flex w-full flex-col overflow-auto rounded-[10px] bg-white py-3 transition-[height] duration-300 ease-in-out"
        style={{ height: isExpanded ? '290px' : '69px' }}
      >
        <div className="flex w-full items-center justify-between gap-2 px-3">
          <div className="flex items-center gap-2">
            <RevertChange />
            <AddScene />
            <AddChapter />
          </div>
          <div className="flex items-center gap-2">
            <PlaybackSpeed />
            <PreviousChapter />
            <PlayPause />
            <PlayerTime />
            <NextChapter />
          </div>
          <div className="flex items-center gap-2">
            <ZoomRange timelineContainerRef={timelineContainerRef} />
            <PlayerTimelineButton
              iconName={isExpanded ? 'IconLayoutNavbarExpand' : 'IconLayoutNavbarCollapse'}
              onClick={() => setIsExpanded(!isExpanded)}
              buttonId="expand-timeline"
              tooltipTitle={isExpanded ? 'Collapse' : 'Expand'}
            />
          </div>
        </div>
      </div>
    </>
  );
};
